export class MapCard extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `
      <div class="map-card-div">
        <img src="./markers/classes.svg"">
        <span class="place-name"></span>
      </div>
     
      <hr>
      <div>
        <div class="info"/>
      </div>
    `

    this.placeName = this.querySelector('span.place-name')
    this.info = this.querySelector('div.info')
    this.mounted = true

    this.render()
  }

  render() {
    if (!this.mounted) {
      return
    }

    const place = this.hasAttribute('place') ? JSON.parse(this.getAttribute('place')) : null,
      universities = this.hasAttribute('universities') ? JSON.parse(this.getAttribute('universities')) : null,
      show = this.hasAttribute('active')

    clearTimeout(this.timer)
    if (show) {
      this.style.visibility = 'visible'
      this.style.opacity = '1'
    } else {
      this.style.opacity = '0'
      this.timer = setTimeout(() => {
        this.style.visibility = 'hidden'
      }, 300)
    }

    this.placeName.innerText = place?.name

    let html = "<ul class='universities'>"
    for (const u of universities ?? []) {
      html += `<li>${u.name}: <ul class="programms">`
      if (u.bachelors) {
        html += `<li>Bachelor course:`
        if ((u.bachelors?.length ?? 0) <= 1) {
          const b = u.bachelors[0] ?? u.bachelors
          html += ` <a href="${b.url}" target="_blank">${b.name}</a>`
        } else {
          html += `<ul class="programms">`
          html += u.bachelors.map(b => `<li><a href="${b.url}" target="_blank">${b.name}</a></li>`).join('')
          html += `</ul>`
        }
        html += `</li>`
      }
      if (u.masters) {
        html += `<li>Master's program:`
        if ((u.masters?.length ?? 0) <= 1) {
          const m = u.masters[0] ?? u.masters
          html += ` <a href="${m.url}" target="_blank">${m.name}</a>`
        } else {
          html += `<ul class="programms">`
          html += u.masters.map(m => `<li><a href="${m.url}" target="_blank">${m.name}</a></li>`)
          html += `</ul>`
        }
        html += `</li>`
      }

      html += `</ul></li>`
    }
    html += "</ul>"
    this.info.innerHTML = html
  }

  static get observedAttributes() {
    return ['place', 'universities', 'active'];
  }

  attributeChangedCallback() {
    this.render();
  }
}

